export const getProductNameByLanguage = (product, language) => {
  return language === 'vi' ? product?.Product_Name : product?.Product_Name_Eng;
};
